const ConfirmDialog = ({
  open,
  title = "Confirm",
  message,
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-[400px] p-3 shadow-lg">
        <h3 className="text-lg font-bold mb-2 ">{title}</h3>
        <p className="text-sm text-gray-600 mb-4 font-medium">{message}</p>

        <div className="flex justify-end gap-3 ">
          <button
            onClick={onCancel}
            className="px-4 py-2 border rounded hover:bg-gray-100 font-medium"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 font-medium"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
